(function ($) {
	var intervalId = null;
	var confetti;
	var confettiLoaded = false;
	var animationEnded = false;
	var run = true;
	var obj = {};
	setTimeout(function () {
		intervalId = setInterval(function () {
			if($(".product__quantityDiscount .easter-egg").length) {
				$(".product__quantityDiscount .easter-egg").removeClass("animate__shake-the-egg");
				$(".product__quantityDiscount .easter-egg")[0].offsetHeight;
				$(".product__quantityDiscount .easter-egg").addClass("animate__shake-the-egg");
			}
		}, 6000);
	}, 3000);

	$(".product__quantityDiscount .easter-egg-wrapper").click(function () {
		$(".product__quantityDiscount .qd").removeClass("active");

		if (run) {
			run = false;
			clearInterval(intervalId);
			loadConfetti();
			$(".product__quantityDiscount .easter-egg").removeClass("animate__shake-the-egg");

			$(".pulsating-background").animate(
				{
					width: "100%",
				},
				1000,
				function () {
					$(".pulsating-background").addClass("pulsing");
					animationEnded = true;
					if (confettiLoaded) {
						blowConfetti();
					}
				}
			);
		}
	});

	if($('.easter-egg-wrapper').length) {
		obj = {
			event_category: $('body').data('productId'),
			event_action: "impression_easter_egg",
			event_label: $('body').data('productId')
		};
		gatgEvent(obj);
	}

	function loadConfetti() {
		var script = document.createElement("script");
		script.src = $("#deferredWaveScripts").data("confetti");
		script.onload = function () {
			confettiLoaded = true;
			if (animationEnded) {
				blowConfetti();
			}
		};
		script.async = true;
		document.head.appendChild(script);
	}

	function blowConfetti() {
		confetti = new wave__confetti({ duration: 3000 });
		confetti.run();

		$(".product__quantityDiscount").addClass("egg-selected");
		$(".pulsating-background").removeClass("pulsing");
		$(".product__quantityDiscount .easter-egg").css("opacity", "0");
		setTimeout(function () {
			$(".easter-egg-wrapper").addClass("activated");
			$(".pulsating-background").remove();

			$(".easter-egg-wrapper .qd-teaser > span").fadeIn().css("display", "block");
			$(".easter-egg-wrapper .price-info").fadeIn();
		}, 500);
	}
})(jQuery);
